import React, { useState } from "react";
import { motion } from "framer-motion";
import { FaLeaf, FaCoffee, FaSoap, FaTint, FaShoppingCart, FaSeedling, FaAppleAlt, FaCarrot, FaLemon, FaPepperHot, FaBroom, FaEyeDropper, FaHandSparkles, FaMask } from "react-icons/fa";
import "tailwindcss/tailwind.css";
import Foo from './components/Swipper'
import FeatureSection from './components/Youtube'
import CeoRecommendation from './components/Ceo'
import QASection from './components/promo'
import Example from './components/Header'
import BestSellingFeature from './components/feautures'
import CustomerFeedback from './components/selling'
import VitaminCTimeline from './components/discount'
import PricingSection from './components/insta'
import Footer from './components/Footer'
import BlogSection from './components/blog'













    const categories = [
      { name: "スキンケア", icon: <FaSoap className="text-[#5a6135] text-2xl" /> },
      { name: "フェイスクリーム", icon: <FaEyeDropper className="text-[#777e4f] text-2xl" /> },
      { name: "クレンジング", icon: <FaBroom className="text-[#777e4f] text-2xl" /> },
      { name: "美容液", icon: <FaTint className="text-[#777e4f] text-2xl" /> },
      { name: "オーガニックソープ", icon: <FaMask className="text-[#777e4f] text-2xl" /> },
      { name: "オーガニック化粧品", icon: <FaLeaf className="text-[#777e4f] text-2xl" /> },
      // { name: "ヘアケア", icon: <FaComb className="text-[#777e4f] text-2xl" /> },
      { name: "ボディケア", icon: <FaHandSparkles className="text-[#777e4f] text-2xl" /> }
    ];
    
  

    const products = [
      // スキンケア (Skincare)
      { 
        category: "スキンケア", 
        name: "オーガニックバーム", 
        price: "2,800円", 
        image: "https://inyoumarket.com/public/media/webp/2023/02/63ed7a120b16c-xl.webp", 
        description: "100%オーガニック成分で作られたスキンケアバーム。乾燥肌に最適です。"
      },
      { 
        category: "スキンケア", 
        name: "フェイスクリーム", 
        price: "3,200円", 
        image: "https://inyoumarket.com/public/media/webp/2024/12/675bdfb268273-xl.webp", 
        description: "天然成分で作られた保湿フェイスクリーム。しっとりとした肌に導きます。"
      },
      { 
        category: "スキンケア", 
        name: "クレンジングオイル", 
        price: "1,800円", 
        image: "https://inyoumarket.com/public/media/webp/2024/12/675be0d889846-xl.webp", 
        description: "肌に優しいオーガニッククレンジングオイル。メイクや汚れをしっかりと落とします。"
      },
      { 
        category: "スキンケア", 
        name: "オーガニックフェイスマスク", 
        price: "1,200円", 
        image: "https://inyoumarket.com/public/media/webp/2022/05/6290a2aa208b3-xl.webp", 
        description: "天然オーガニック成分を使用したフェイスマスク。肌をリフレッシュし、潤いを与えます。"
      },
    
      // フェイスクリーム (Face Cream)
      { 
        category: "フェイスクリーム", 
        name: "保湿フェイスクリーム", 
        price: "3,500円", 
        image: "https://inyoumarket.com/public/media/webp/2022/05/6290a2aa208b3-xl.webp", 
        description: "ナチュラル成分を使用した高保湿フェイスクリーム。"
      },
      { 
        category: "フェイスクリーム", 
        name: "ビタミンC フェイスクリーム", 
        price: "4,000円", 
        image: "https://inyoumarket.com/public/media/webp/2023/07/64a210466a9d5-xl.webp", 
        description: "ビタミンC配合で肌を明るく健康的に導くフェイスクリーム。"
      },
      { 
        category: "フェイスクリーム", 
        name: "オーガニックデイクリーム", 
        price: "3,800円", 
        image: "https://inyoumarket.com/public/media/webp/2023/04/642cc99ed944b-xl.webp", 
        description: "紫外線対策にも適したデイクリーム。軽い付け心地が特徴。"
      },
      { 
        category: "フェイスクリーム", 
        name: "ナイトリペアクリーム", 
        price: "4,500円", 
        image: "https://inyoumarket.com/public/media/webp/2023/01/63c8ce9cb205f-xl.webp", 
        description: "夜のスキンケアに最適なリッチな保湿クリーム。"
      },
    
      // クレンジング (Cleansing)
      { 
        category: "クレンジング", 
        name: "オーガニッククレンジングミルク", 
        price: "2,500円", 
        image: "https://inyoumarket.com/public/media/webp/2023/01/63c8cdb384d68-xl.webp", 
        description: "敏感肌にも優しいクレンジングミルク。"
      },
      { 
        category: "クレンジング", 
        name: "ディープクレンジングオイル", 
        price: "3,000円", 
        image: "https://inyoumarket.com/public/media/webp/2024/02/65c188e90647f-xl.webp", 
        description: "メイクをしっかり落としつつ、肌の潤いを守るクレンジングオイル。"
      },
      { 
        category: "クレンジング", 
        name: "ナチュラルクレンジングフォーム", 
        price: "2,000円", 
        image: "https://inyoumarket.com/public/media/webp/2023/08/64ee88222a3a0-xl.webp", 
        description: "泡立ちの良い、優しい使い心地のクレンジングフォーム。"
      },
      { 
        category: "クレンジング", 
        name: "炭入りクレンジングウォーター", 
        price: "2,800円", 
        image: "https://inyoumarket.com/public/media/webp/2022/05/6290a2aa208b3-xl.webp", 
        description: "毛穴汚れをすっきり落とす炭入りクレンジングウォーター。"
      },
    
      // 美容液 (Serums)
      { 
        category: "美容液", 
        name: "オーガニックビタミンC美容液", 
        price: "5,000円", 
        image: "https://inyoumarket.com/public/media/webp/2023/08/64ee869859bf8-xl.webp", 
        description: "肌を明るく保つビタミンC配合の美容液。"
      },
      { 
        category: "美容液", 
        name: "保湿美容液", 
        price: "4,200円", 
        image: "https://inyoumarket.com/public/media/webp/2023/08/64ee88222a3a0-xl.webp", 
        description: "乾燥肌のための高保湿美容液。"
      },
      { 
        category: "美容液", 
        name: "エイジングケア美容液", 
        price: "6,000円", 
        image: "https://inyoumarket.com/public/media/webp/2023/09/650c0f5e32f9e-xl.webp", 
        description: "アンチエイジングに適した美容液。"
      },
      { 
        category: "美容液", 
        name: "リフトアップ美容液", 
        price: "5,500円", 
        image: "https://inyoumarket.com/public/media/webp/2023/08/64ee87885d6a8-xl.webp", 
        description: "肌の引き締めをサポートするリフトアップ美容液。"
      },



      { 
        category: "オーガニックソープ", 
        name: "ラベンダーオーガニックソープ", 
        price: "1,200円", 
        image: "https://inyoumarket.com/public/media/webp/2025/03/67ceb038db0ff-xl.webp",
        description: "心を落ち着かせるラベンダーの香りのオーガニックソープ。"
      },
      { 
        category: "オーガニックソープ", 
        name: "シアバターソープ", 
        price: "1,500円", 
        image: "https://inyoumarket.com/public/media/webp/2023/09/650a9fef4ed42-xl.webp",
        description: "高保湿シアバター配合の優しい使い心地のソープ。"
      },
      { 
        category: "オーガニックソープ", 
        name: "炭石鹸 (ディープクレンジング)", 
        price: "1,800円", 
        image: "https://inyoumarket.com/public/media/webp/2023/09/650941d662a55-xl.webp",
        description: "毛穴の汚れをしっかり吸着する炭入りオーガニックソープ。"
      },
      { 
        category: "オーガニックソープ", 
        name: "ハニー&オートミールソープ", 
        price: "1,600円", 
        image: "https://inyoumarket.com/public/media/webp/2023/09/6509423d61fe9-xl.webp",
        description: "ハチミツとオートミール配合で肌にやさしい保湿石鹸。"
      }
      ,
    
        // マスク (Mask)
        { 
          category: "マスク", 
          name: "オーガニックフェイスマスク", 
          price: "1,500円", 
          image: "https://inyoumarket.com/public/media/webp/2025/03/67ceb038db0ff-xl.webp",
          description: "天然成分配合のフェイスマスク。お肌に潤いを与え、ハリを保ちます。" 
        },
        { 
          category: "マスク", 
          name: "クレイマスク", 
          price: "2,200円", 
          image: "https://inyoumarket.com/public/media/webp/2023/09/650a9fef4ed42-xl.webp",
          description: "毛穴の汚れを取り除く天然クレイマスク。"
        },
        { 
          category: "マスク", 
          name: "シートマスク (ヒアルロン酸配合)", 
          price: "1,800円", 
          image: "https://inyoumarket.com/public/media/webp/2023/09/650941d662a55-xl.webp",
          description: "ヒアルロン酸たっぷりのシートマスクでしっかり保湿。"
        },
        { 
          category: "マスク", 
          name: "コラーゲンフェイスマスク", 
          price: "2,500円", 
          image: "https://inyoumarket.com/public/media/webp/2023/09/6509423d61fe9-xl.webp",
          description: "エイジングケアに最適なコラーゲン配合のマスク。"
        },
      
        // オーガニック化粧品 (Organic Cosmetics)
        { 
          category: "オーガニック化粧品", 
          name: "オーガニックリップバーム", 
          price: "1,200円", 
          image: "https://inyoumarket.com/public/media/webp/2024/05/664c5e9a18b25-xl.webp",
          description: "100%ナチュラル成分のリップバーム。"
        },
        { 
          category: "オーガニック化粧品", 
          name: "ナチュラルBBクリーム", 
          price: "3,000円", 
          image: "https://inyoumarket.com/public/media/webp/2024/12/675bdeae90ace-xl.webp",
          description: "肌に優しく、しっかりカバーできるオーガニックBBクリーム。"
        },
        { 
          category: "オーガニック化粧品", 
          name: "ミネラルファンデーション", 
          price: "3,800円", 
          image: "https://inyoumarket.com/public/media/webp/2023/09/64f54f2289cc4-xl.webp",
          description: "天然ミネラル成分を使用した軽いつけ心地のファンデーション。"
        },
        { 
          category: "オーガニック化粧品", 
          name: "ナチュラルチーク", 
          price: "2,500円", 
          image: "https://inyoumarket.com/public/media/webp/2022/05/6290a2aa208b3-xl.webp",
          description: "肌に馴染みやすいオーガニックチーク。"
        },
      
        // ボディケア (Body Care)
        { 
          category: "ボディケア", 
          name: "オーガニックボディローション", 
          price: "2,800円", 
          image: "https://inyoumarket.com/public/media/webp/2023/07/64ab97b0f4184-xl.webp",
          description: "しっとり肌を保つ天然オイル配合のボディローション。"
        },
        { 
          category: "ボディケア", 
          name: "ナチュラルボディスクラブ", 
          price: "3,200円", 
          image: "https://inyoumarket.com/public/media/webp/2023/07/64ab8fc24a45d-xl.webp",
          description: "古い角質を優しく取り除くオーガニックボディスクラブ。"
        },
        { 
          category: "ボディケア", 
          name: "オーガニックボディソープ", 
          price: "2,000円", 
          image: "https://inyoumarket.com/public/media/webp/2023/07/64ab8f0f9c968-xl.webp",
          description: "敏感肌にも使える低刺激なボディソープ。"
        },
        { 
          category: "ボディケア", 
          name: "アロママッサージオイル", 
          price: "3,500円", 
          image: "https://inyoumarket.com/public/media/webp/2022/07/62ccd22a3e326-xl.webp",
          description: "リラックス効果のあるアロマオイル配合のマッサージオイル。"
        }
      ];
      
    
    

const LandingPage = () => {
  const [selectedCategory, setSelectedCategory] = useState("スキンケア");

  return (
    <div className="font-sans ">
      {/* <nav className=" w-full bg-white shadow-md py-4 px-6 flex justify-between items-center z-50">
        <img src="https://inyoumarket.com/public/dist/img/logo.png" alt="ロゴ" className="w-28" />
        <div className="flex gap-6 text-green-700 font-semibold">
          <a href="#about">オーガニックとは？</a>
          <a href="#products">商品一覧</a>
          <a href="#contact">お問い合わせ</a>
        </div>
      </nav> */}
      
{/* 
<nav className="bg-white border-gray-200 dark:bg-gray-900 shadow-md">
  <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
    <a href="/" className="flex items-center space-x-3 rtl:space-x-reverse">
    <img src="https://inyoumarket.com/public/dist/img/logo.png" alt="ロゴ" className="w-28" />
       
    </a>
    <button data-collapse-toggle="navbar-default" type="button" className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600" aria-controls="navbar-default" aria-expanded="false">
        <span className="sr-only">Open main menu</span>
        <svg className="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 14">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 1h15M1 7h15M1 13h15"/>
        </svg>
    </button>
    <div className="hidden w-full md:block md:w-auto" id="navbar-default">
      <ul className="font-medium flex flex-col p-4 md:p-0 mt-4 border border-gray-100 rounded-lg bg-gray-50 md:flex-row md:space-x-8 rtl:space-x-reverse md:mt-0 md:border-0 md:bg-white dark:bg-gray-800 md:dark:bg-gray-900 dark:border-gray-700">
        <li>
          <a href="#" className="block py-2 px-3 text-white bg-green-600 rounded-sm md:bg-transparent md:text-green-600 md:p-0 dark:text-white md:dark:text-blue-500" aria-current="page">Home</a>
        </li>
        <li>
          <a href="#" className="block py-2 px-3 text-gray-900 rounded-sm hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-green-600 md:p-0 dark:text-white md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent">About</a>
        </li>
        <li>
          <a href="#" className="block py-2 px-3 text-gray-900 rounded-sm hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-green-600 md:p-0 dark:text-white md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent">Services</a>
        </li>
        <li>
          <a href="#" className="block py-2 px-3 text-gray-900 rounded-sm hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-green-600 md:p-0 dark:text-white md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent">Pricing</a>
        </li>
        <li>
          <a href="#" className="block py-2 px-3 text-gray-900 rounded-sm hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-green-600 md:p-0 dark:text-white md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent">Contact</a>
        </li>
      </ul>
    </div>
  </div>
</nav> */}
<section>
<Example/>
</section>

     
      <section className="relative">
      <Foo/>

      <section>
      <div className="px-4 sm:px-6 lg:px-8 py-32 ">
  {/* Grid */}
  <div className="grid md:grid-cols-1 gap-4 md:gap-8 xl:gap-20 items-center justify-center text-center">
    <div>
      {/* <h1 className="block text-3xl font-bold text-gray-800 sm:text-4xl lg:text-6xl lg:leading-tight dark:text-white mb-4">
        <span className=" underline decoration-yellow-400">“「1滴のビタミンCで、くすみ知らずの輝きへ」”</span>
      </h1> */}
      <blockquote className="relative text-center  mx-auto ">
  <div className="relative">
    <p className="text-7xl text-gray-800">
      <em className="relative">
        <svg className="absolute -top-8 -start-8 size-16 text-gray-500 sm:h-24 sm:w-24 " width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M7.39762 10.3C7.39762 11.0733 7.14888 11.7 6.6514 12.18C6.15392 12.6333 5.52552 12.86 4.76621 12.86C3.84979 12.86 3.09047 12.5533 2.48825 11.94C1.91222 11.3266 1.62421 10.4467 1.62421 9.29999C1.62421 8.07332 1.96459 6.87332 2.64535 5.69999C3.35231 4.49999 4.33418 3.55332 5.59098 2.85999L6.4943 4.25999C5.81354 4.73999 5.26369 5.27332 4.84476 5.85999C4.45201 6.44666 4.19017 7.12666 4.05926 7.89999C4.29491 7.79332 4.56983 7.73999 4.88403 7.73999C5.61716 7.73999 6.21938 7.97999 6.69067 8.45999C7.16197 8.93999 7.39762 9.55333 7.39762 10.3ZM14.6242 10.3C14.6242 11.0733 14.3755 11.7 13.878 12.18C13.3805 12.6333 12.7521 12.86 11.9928 12.86C11.0764 12.86 10.3171 12.5533 9.71484 11.94C9.13881 11.3266 8.85079 10.4467 8.85079 9.29999C8.85079 8.07332 9.19117 6.87332 9.87194 5.69999C10.5789 4.49999 11.5608 3.55332 12.8176 2.85999L13.7209 4.25999C13.0401 4.73999 12.4903 5.27332 12.0713 5.85999C11.6786 6.44666 11.4168 7.12666 11.2858 7.89999C11.5215 7.79332 11.7964 7.73999 12.1106 7.73999C12.8437 7.73999 13.446 7.97999 13.9173 8.45999C14.3886 8.93999 14.6242 9.55333 14.6242 10.3Z" fill="currentColor"></path>
        </svg>
        <span className="relative ">    「毎日のスプーン一杯で、健康なあなたへ！」
        </span>
      </em>
    </p>
  </div>
</blockquote>
      <p className="mt-6 text-xl text-gray-800 ">
      健康は内面から始まります—自然の純粋なビタミンCで体を活性化しましょう。
      免疫力を高め、疲れを吹き飛ばし、毎日元気に過ごしましょう！
    <br></br><br></br>
   
        <span className="font-bold text-red-600"> 健康は待ってくれません—この特別なオファーは48時間以内で終了！</span>
      </p>
      {/* Buttons */}
      <div className="mt-12 grid gap-3 w-full sm:inline-flex justify-center">
        <a
          className="py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-lg border border-transparent bg-yellow-500 text-white hover:bg-yellow-600 focus:outline-hidden focus:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none"
          href="/#sell"
        >
           今すぐ購入
          <svg
            className="shrink-0 size-4"
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="m9 18 6-6-6-6" />
          </svg>
        </a>
      </div>
    </div>
  </div>
</div>

      </section>

      <section>
      <div className="px-4 sm:px-6 lg:px-8   ">
  <div className="grid md:grid-cols-2 gap-6 md:gap-10 items-center text-center">
    <div className="space-y-12">
      {/* Main headline */}
      <h2 className="text-4xl font-extrabold text-gray-800 sm:text-5xl lg:text-6xl  underline decoration-yellow-400">
      ビタミンCの力 
      </h2>
      
      {/* Supporting text */}
      <p className="text-xl text-gray-800  leading-relaxed ">
      私たちのビタミンCサプリメントは、科学的に証明された抗酸化作用を備え、健康をサポートします。
      医師や栄養士に信頼される最高品質のナチュラル成分を使用しています。
      </p>
      
      {/* Call to Action */}
      <div className="">
        <a
          className="py-3 px-6 inline-flex justify-center items-center gap-x-3 text-sm font-medium rounded-lg bg-yellow-500 text-white hover:bg-yellow-600"
          href="/#sell"
        >
    今すぐ購入
          <svg
            className="shrink-0"
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="m9 18 6-6-6-6" />
          </svg>
        </a>
      </div>
    </div>

    {/* Image & Expert Testimonial */}
    <div className="space-y-6">
      <div className="flex justify-center gap-6">
        {/* Expert images */}
        <img
          src="https://img.freepik.com/free-photo/bearded-doctor-glasses_23-2147896187.jpg?t=st=1743403939~exp=1743407539~hmac=6bed921c10d8a55d92683b8ac42bdd2d47b074fd573e4b8905eec1a33cd48ec1&w=996"
          alt="Nutritionist"
          className="w-20 h-20 rounded-full object-cover shadow-lg border-4 border-yellow-400"
        />
        <img
          src="https://img.freepik.com/free-photo/doctor-offering-medical-teleconsultation_23-2149329007.jpg?t=st=1743403980~exp=1743407580~hmac=bb56498c3ac736d92e7aa747e32b8f1e5eecb3171d2042717793b8acdf4df875&w=1380"
          alt="Nutritionist"
          className="w-20 h-20 rounded-full object-cover shadow-lg border-4 border-yellow-400"
        />
      </div>

      {/* Expert quote */}
      <p className="text-lg font-semibold text-gray-800  italic">
      「ビタミンCは免疫と美肌に欠かせない栄養素です。私はこのサプリメントを患者さんにお勧めします。」
        — Dr. 山田太郎 (Dr. Yamada Taro), 栄養専門家
      </p>

      {/* Product Image */}
      <div className="mt-6">
        <img
          src="https://inyoumarket.com/public/media/webp/2021/04/VitaminC0426_007-xl.webp"
          alt="Vitamin C Supplement"
          className="w-full h-auto rounded-lg shadow-xl"
        />
      </div>

      {/* Customer Testimonial */}
      <p className="text-md text-gray-800  mt-4 italic">
      「このビタミンCサプリを摂り始めてから、以前よりも元気で健康を実感しています！」 – マーク、認証済みのお客様
      </p>
    </div>
  </div>
</div>


      </section>

      <section className="py-16 ">
  <div className=" mx-auto px-6 text-center">

    {/* Emotional Headline */}
    <h2 className="text-6xl font-extrabold leading-tight text-gray-900 underline decoration-yellow-400">
      疲れやすい？お肌の調子が気になる？  
      <br />ビタミンCで元気な毎日を！
    </h2>

    {/* Emotional Appeal */}
    <p className="mt-6 text-2xl text-gray-700 max-w-3xl mx-auto">
      現代の忙しい生活で、疲れが取れない、肌がくすむ、免疫力が低下する…  
      そんなお悩みを感じていませんか？  
      <span className="font-bold text-gray-900">
        たった1日1回のビタミンC補給で、あなたの体が生まれ変わる！
      </span>
    </p>

    {/* Image Section */}
    <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      <div className="relative group">
        <img src="https://inyoumarket.com/public/media/webp/2021/04/VitaminC0426_003-xl.webp" alt="Vitamin C Supplement 1" className="w-full h-full object-cover rounded-2xl" />
      </div>
      <div className="relative group">
        <img src="https://inyoumarket.com/public/media/webp/2021/04/VitaminC0426_007-xl.webp" alt="Vitamin C Supplement 2" className="w-full h-full object-cover rounded-2xl" />
      </div>
      <div className="relative group">
        <img src="https://inyoumarket.com/public/media/webp/2021/04/VitaminC0426_005-xl.webp" alt="Vitamin C Supplement 3" className="w-full h-full object-cover rounded-2xl" />
      </div>
    </div>

    {/* Limited-Time Offer */}
    <div className="text-center mt-12">
      <p className="text-2xl font-medium text-red-500">
         期間限定！今なら30%オフ 
      </p>
      <p className="mt-2 text-lg text-gray-700">
        今すぐ購入して、毎日の健康と美しさを手に入れましょう。
      </p>
      <a href="/#sell" className="bg-yellow-400 hover:bg-yellow-500 text-black font-bold py-3 px-8 rounded-full mt-6 inline-block transition duration-300">
        今すぐ割引をゲット！
      </a>
    </div>

    {/* Social Proof - Testimonial */}
    <div className="mt-12 text-center bg-white p-6 rounded-2xl  max-w-3xl mx-auto">
      <p className="text-2xl italic text-gray-700">
        「このビタミンCサプリは革命的！毎朝スッキリ目覚めて、  
        肌が輝くのを感じます。もう手放せません！」
      </p>
      <span className="block text-lg mt-2 font-semibold text-gray-900">- Emma L.</span>
    </div>

    {/* Urgency Message */}
    <div className="mt-8 text-center">
      <p className="font-semibold text-2xl sm:text-xl text-red-500">
        在庫限り！お早めにご注文ください！
      </p>
    </div>

  </div>
</section>

      
{/* 
      <section>
  
<div className="bg-white py-16">

  <div className="max-w-7xl mx-auto px-6 lg:px-8">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
      <div className="order-2 lg:order-1">
        <h2 className="text-3xl font-bold text-gray-900 mb-4">
          Discover the Power of Vitamin C
        </h2>
        <p className="text-lg text-gray-700">
          Our Vitamin C supplement is packed with the finest ingredients to boost your immunity and protect your skin. Whether you're looking to fight free radicals, improve collagen production, or simply stay healthy, this is the perfect addition to your daily routine.
        </p>
      </div>
      <div className="order-1 lg:order-2">
        <img src="vitamin-c-ingredients1.jpg" alt="Vitamin C Ingredients" className="w-full rounded-lg shadow-lg" />
      </div>
    </div>
  </div>


  <div className="max-w-7xl mx-auto px-6 lg:px-8 mt-16">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
      <div>
        <img src="vitamin-c-ingredients2.jpg" alt="Vitamin C Benefits" className="w-full rounded-lg shadow-lg" />
      </div>
      <div className="mt-8 lg:mt-0">
        <h2 className="text-3xl font-bold text-gray-900 mb-4">
          Packed with Powerful Antioxidants
        </h2>
        <p className="text-lg text-gray-700">
          Our Vitamin C formula includes natural antioxidants that fight oxidative stress, support cellular repair, and help your body stay healthy. These powerful ingredients help combat the effects of aging, leaving you feeling youthful and vibrant.
        </p>
      </div>
    </div>
  </div>


  <div className="max-w-7xl mx-auto px-6 lg:px-8 mt-16">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
      <div className="order-2 lg:order-1">
        <h2 className="text-3xl font-bold text-gray-900 mb-4">
          Glowing Skin Starts Here
        </h2>
        <p className="text-lg text-gray-700">
          Vitamin C is essential for collagen production, a key element in keeping your skin elastic, smooth, and youthful. Our formula enhances the natural glow of your skin by supporting healthy cell regeneration. Say goodbye to dull and uneven skin tone.
        </p>
      </div>
      <div className="order-1 lg:order-2">
        <img src="vitamin-c-skin-benefits.jpg" alt="Vitamin C Glowing Skin" className="w-full rounded-lg shadow-lg" />
      </div>
    </div>
  </div>

  
  <div className="max-w-7xl mx-auto px-6 lg:px-8 mt-16">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
      <div>
        <img src="vitamin-c-energy-boost.jpg" alt="Vitamin C Energy Boost" className="w-full rounded-lg shadow-lg" />
      </div>
      <div className="mt-8 lg:mt-0">
        <h2 className="text-3xl font-bold text-gray-900 mb-4">
          Feel Energized All Day
        </h2>
        <p className="text-lg text-gray-700">
          Start your day right with an energy boost from Vitamin C. Not only does it support your immune system, but it also helps to increase your energy levels, keeping you active and alert throughout the day. Perfect for people with busy lifestyles.
        </p>
      </div>
    </div>
  </div>

  
  <div className="max-w-7xl mx-auto px-6 lg:px-8 mt-16">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
      <div className="order-2 lg:order-1">
        <h2 className="text-3xl font-bold text-gray-900 mb-4">
          Convenient and Easy to Use
        </h2>
        <p className="text-lg text-gray-700">
          Our Vitamin C supplement comes in easy-to-swallow tablets that can be taken on-the-go. Whether you're at home, work, or traveling, you can enjoy all the benefits of Vitamin C without the hassle. No mess, no stress!
        </p>
      </div>
      <div className="order-1 lg:order-2">
        <img src="vitamin-c-convenient-use.jpg" alt="Convenient Use of Vitamin C" className="w-full rounded-lg shadow-lg" />
      </div>
    </div>
  </div>

 
  <div className="text-center mt-16">
    <h2 className="text-3xl font-bold text-gray-900 mb-4">Transform Your Health Today</h2>
    <p className="text-lg text-gray-700 mb-8">
      Don't wait to experience the benefits of Vitamin C. Order now and start living your healthiest life today!
    </p>
    <a href="#" className="bg-yellow-500 hover:bg-yellow-600 text-black font-bold py-3 px-8 rounded-full inline-block transition duration-300">
      Shop Now
    </a>
  </div>
</div>

      </section> */}
  {/* Background Image */}
  {/* <div className="absolute top-0 left-0 w-full h-full bg-cover bg-center opacity-40" style={{ backgroundImage: "url('https://inyoumarket.com/public/media/webp/2025/01/678762cb2b6c5.webp')" }}></div> */}

  {/* Banner Content */}

  {/* <motion.h1

    className="text-5xl font-extrabold tracking-tight leading-tight relative z-10"
    initial={{ opacity: 0, y: -50 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 1 }}
  >
    健康的な生活をオーガニックで
  </motion.h1> */}

  {/* CTA Button */}
  {/* <motion.a
    href="#products"
    className="mt-6 inline-block py-3 px-6 bg-green-600 text-white rounded-full text-lg font-semibold transition duration-300  hover:bg-green-700"
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 1, delay: 0.5 }}
  >
    今すぐ見る
  </motion.a> */}
 
</section>
{/* <FeaturedProducts/>
<ExclusiveOffers/> */}
 

<section>

<section className="py-20 bg-white ">
  <div className="mx-auto px-6 sm:px-8 lg:px-16">
  
    <div className="text-center mb-16">
      <h2 className="  font-bold text-gray-800 sm:text-2xl md:text-7xl  underline decoration-yellow-400 inline-block pb-3">
      自然の力、一さじに凝縮
      </h2>
      <p className="text-xl text-gray-600  mt-6">
      あなたのビタミンCサプリメントに詰まった、自然のスーパーヒーローたちをご紹介します！
      </p>
    </div>

      <div className="space-y-16">
      
 
      <div className="flex items-center space-x-12">
        <div className="w-1/2">
          <img src="https://inyoumarket.com/public/media/webp/2021/04/VitaminC0426_007-xl.webp" alt="Vitamin C Bottle" className="w-full h-auto rounded-2xl   transition-all duration-300"/>
        </div>
        <div className="w-1/2 space-y-6">
          <h3 className="text-3xl text-yellow-600 font-bold">毎日のビタミンCで元気いっぱい！</h3>
          <p className="text-xl text-gray-800  leading-relaxed">
          「私はあなたの健康サポーター！3000mgの純粋で自然なビタミンCで、毎日元気に、エネルギッシュに、そして輝く肌をサポートします！」
          </p>
          <ul className="list-disc pl-6 text-lg text-gray-800  space-y-2">
            <li>免疫力を強化</li>
            <li>疲れを撃退し、エネルギーをアップ</li>
            <li>肌の輝きをアップ </li>
          </ul>
        </div>
      </div>

 
      <div className="flex items-center space-x-8 flex-row-reverse">
        <div className="w-1/2">
          <img src="https://img.freepik.com/free-photo/object-green-leaf-plant-food_1417-432.jpg?t=st=1743411434~exp=1743415034~hmac=d29ef275de09854f2532a3bb2f6888fb95da9014beafa956e8721fd4638440ce&w=1380" alt="Acerola Cherry" className="w-full h-auto rounded-2xl   transition-all duration-300"/>
        </div>
        <div className="w-1/2 space-y-6">
          <h3 className="text-3xl text-yellow-600 font-bold"> こんにちは！私はアセロラチェリーです</h3>
          <p className="text-xl text-gray-800  leading-relaxed">
          「私は自然のビタミンCのパワーハウス！オレンジの50倍ものビタミンCを含んでいて、風邪を予防し、肌を改善し、免疫力を強化します！」
          </p>
          <ul className="text-lg text-gray-800 pl-6  leading-relaxed list-disc list-inside space-y-2">
  <li>自然のビタミンCパワーハウス</li>
  <li>オレンジの50倍のビタミンCを含む</li>
  <li>予防と免疫力強化</li>
  <li>肌の健康とコラーゲン生成をサポート</li>
</ul>
        </div>
      </div>


      <div className="flex items-center space-x-12">
        <div className="w-1/2">
          <img src="https://img.freepik.com/free-photo/side-view-dogwood-wooden-bowl-white-background_141793-49413.jpg?t=st=1743411521~exp=1743415121~hmac=c3f84f7cf611f0ad670249bfa4436d89b4cab21610b65a98f76a137ec2108d5b&w=1380" alt="Camu Camu Fruit" className="w-full h-auto rounded-2xl   transition-all duration-300"/>
        </div>
        <div className="w-1/2 space-y-6">
          <h3 className="text-3xl text-yellow-600 font-bold"> 私はカムカム、あなたの肌のベストフレンド！</h3>
          <p className="text-xl text-gray-800  leading-relaxed">
          「私はあなたの肌が輝くように、こっそりサポートしています。豊富な抗酸化物質で、早期の老化を防ぎ、コラーゲンの生成をサポートします。」
          </p>
          <ul className="text-lg text-gray-800  leading-relaxed list-disc list-inside space-y-2">
  <li>自然に肌の輝きをアップ</li>
  <li>抗酸化物質が豊富で、早期の老化を防ぐ</li>
  <li>コラーゲン生成をサポートし、若々しい肌を維持</li>
</ul>

        </div>
      </div>


      <div className="flex items-center space-x-12 flex-row-reverse">
        <div className="w-1/2">
          <img src="https://img.freepik.com/free-photo/top-view-fresh-orange-juice-with-oranges-citruses-light-white-surface-citrus-exotic-tropical-fruit-juice_140725-64779.jpg?t=st=1743421167~exp=1743424767~hmac=f5428a4532647eaf74860114eefc716704295f4325bd2e0806adefbe7ad507f6&w=1380" alt="Organic Orange Extract" className="w-full h-auto rounded-2xl   transition-all duration-300"/>
        </div>
        <div className="w-1/2 space-y-6">
          <h3 className="text-3xl text-yellow-600 font-bold"> 私はオーガニックオレンジエキスです</h3>
          <p className="text-xl text-gray-800  leading-relaxed">
          「私はあなたの自然な免疫ブースター！ビタミンCの吸収を助けるバイオフラボノイドがたっぷり含まれています！」
          </p>
          <ul className="text-lg text-gray-800 pl-6 leading-relaxed list-disc list-inside space-y-2">
  <li>自然な免疫ブースター</li>
  <li>バイオフラボノイドが豊富</li>
  <li>ビタミンCの吸収をサポート</li>
</ul>

        </div>
      </div>


      <div className="flex items-center space-x-12">
        <div className="w-1/2">
          <img src="https://img.freepik.com/free-photo/boiling-hot-water-tea-arrangement_23-2149088653.jpg?t=st=1743421623~exp=1743425223~hmac=fc6cf9e42592e337fd8efaa105ff290da1a6087461dd7768fd4a1c7cd55cb917&w=1380" alt="Raw Manufacturing Process" className="w-full h-auto rounded-2xl   transition-all duration-300"/>
        </div>
        <div className="w-1/2 space-y-6">
          <h3 className="text-3xl text-yellow-600 font-bold"> 純粋で生の製造プロセス</h3>
          <p className="text-xl text-gray-800  leading-relaxed">
          「私は自然な栄養素を守るために、低温処理を使用しています。合成アスコルビン酸は使わず、純粋な良さだけをお届けします！」
          </p>
          <ul className="text-lg text-gray-800  leading-relaxed list-disc list-inside space-y-2">
  <li> 低温処理で自然な栄養素を保持</li>
  <li> 合成アスコルビン酸不使用</li>
  <li>100％純粋で自然な良さ</li>
</ul>

        </div>
      </div>


      <div className="flex items-center space-x-12 flex-row-reverse">
        <div className="w-1/2">
          <img src="https://inyoumarket.com/public/media/2021/04/VitaminC0426_013.jpg" alt="Vitamin C Benefits" className="w-full h-auto rounded-2xl   transition-all duration-300"/>
        </div>
        <div className="w-1/2 space-y-6">
          <h3 className="text-3xl text-yellow-600 font-bold"> 毎日の守り神！</h3>
          <p className="text-xl text-gray-800  leading-relaxed">
          「毎日一さじで、病院いらず！最高の自然なビタミンCで、風邪やインフルエンザ、感染症から守ります。」
          </p>
          <ul className="text-lg text-gray-800  leading-relaxed list-disc list-inside space-y-2">
  <li> 毎日一さじで完全な守り</li>
  <li> 風邪、インフルエンザ、感染症から守る</li>
  <li>自然なビタミンCで免疫力強化</li>
</ul>

        </div>
      </div>


      <div className="mt-12 text-center">
        <a href="/#sell" className="bg-yellow-500 text-white rounded-2xl py-4 px-8  font-semibold text-lg hover:bg-yellow-600 transition-all">
        今すぐ購入して、毎日の一さじで3000mgのビタミンCをゲット！
        </a>
      </div>
    </div>
  </div>
</section>


</section>
<VitaminCTimeline/>

<CustomerFeedback/>

<section className="p-8 py-16">

<h2 className="text-7xl text-center font-extrabold text-gray-900   underline decoration-yellow-500">
比較表 
        </h2>

  <div className="overflow-x-auto mt-12">
    <table className="w-full rounded-xl  border-4 border-yellow-500">
      <thead>
        <tr className="bg-yellow-200 text-2xl text-gray-900 font-extrabold">
          <th className="border-2 border-yellow-500 p-5">特徴 (Feature)</th>
          <th className="border-2 border-yellow-500 p-5">Minery Vitamin C</th>
          <th className="border-2 border-yellow-500 p-5">Synthetic Vitamin C</th>
        </tr>
      </thead>
      <tbody>
        <tr className="bg-white text-xl">
          <td className="border-2 border-yellow-500 p-4">原材料 (Ingredients)</td>
          <td className="border-2 border-yellow-500 p-4 text-green-600">アセロラ, カカドゥプラム</td>
          <td className="border-2 border-yellow-500 p-4 text-gray-500">人工アスコルビン酸</td>
        </tr>
        <tr className="bg-yellow-50 text-xl">
          <td className="border-2 border-yellow-500 p-4">吸収率 (Absorption)</td>
          <td className="border-2 border-yellow-500 p-4 text-green-600">高い (High, Natural)</td>
          <td className="border-2 border-yellow-500 p-4 text-gray-500">低い (Low, Artificial)</td>
        </tr>
        <tr className="bg-white text-xl">
          <td className="border-2 border-yellow-500 p-4">添加物 (Additives)</td>
          <td className="border-2 border-yellow-500 p-4 text-green-600">なし (None)</td>
          <td className="border-2 border-yellow-500 p-4 text-gray-500">あり (Synthetic Fillers)</td>
        </tr>
        <tr className="bg-yellow-50 text-xl">
          <td className="border-2 border-yellow-500 p-4">GMO</td>
          <td className="border-2 border-yellow-500 p-4 text-green-600">非GMO (Non-GMO)</td>
          <td className="border-2 border-yellow-500 p-4 text-gray-500">GMO由来 (GMO-based)</td>
        </tr>
        <tr className="bg-white text-xl">
          <td className="border-2 border-yellow-500 p-4">ビタミンC濃度 (Vitamin C Concentration)</td>
          <td className="border-2 border-yellow-500 p-4 text-green-600">高濃度 (Highly Concentrated)</td>
          <td className="border-2 border-yellow-500 p-4 text-gray-500">低濃度 (Lower Concentration)</td>
        </tr>
        <tr className="bg-yellow-50 text-xl">
          <td className="border-2 border-yellow-500 p-4">吸収の速さ (Absorption Speed)</td>
          <td className="border-2 border-yellow-500 p-4 text-green-600">迅速 (Fast)</td>
          <td className="border-2 border-yellow-500 p-4 text-gray-500">遅い (Slow)</td>
        </tr>
        <tr className="bg-white text-xl">
          <td className="border-2 border-yellow-500 p-4">副作用 (Side Effects)</td>
          <td className="border-2 border-yellow-500 p-4 text-green-600">なし (None)</td>
          <td className="border-2 border-yellow-500 p-4 text-gray-500">胃腸の不快感 (Digestive Issues)</td>
        </tr>
        <tr className="bg-yellow-50 text-xl">
          <td className="border-2 border-yellow-500 p-4">価格 (Price)</td>
          <td className="border-2 border-yellow-500 p-4 text-green-600">リーズナブル (Reasonable)</td>
          <td className="border-2 border-yellow-500 p-4 text-gray-500">安価だが品質低 (Cheap but Low Quality)</td>
        </tr>
      </tbody>
    </table>
  </div>
</section>


<section>
  
</section>

<QASection/>
<PricingSection/>

<section className="py-16 ">
  <div className=" mx-auto px-6 text-center">

    {/* High-Quality Visual Appeal */}
    <div className="relative">
      <img src="https://inyoumarket.com/public/media/webp/2021/04/VitaminC0426_003-xl.webp" 
        alt="Vitamin C Supplement" 
        className="w-full h-96 object-cover rounded-3xl shadow-lg border border-yellow-300">
      </img>
      <div className="absolute inset-0 bg-black opacity-10 rounded-3xl"></div>
    </div>

    {/* Main Selling Point */}
    <h2 className="mt-8 text-6xl font-extrabold text-gray-900 leading-tight">
      日本のために厳選されたビタミンC、<br />今すぐ体感しませんか？
    </h2>

    <p className="mt-4 text-2xl text-gray-700 max-w-3xl mx-auto">
      <span className="font-bold text-gray-900">高品質・無添加</span>のビタミンCで、  
      <span className="text-red-500 font-semibold">免疫力アップ、美肌、毎日の元気</span>をサポート！  
      今すぐ始めて、体の変化を実感してください。
    </p>

    {/* Limited-Time Offer */}
    {/* <p className="mt-6 text-xl font-semibold text-red-600 bg-yellow-200 px-4 py-2 inline-block rounded-lg shadow-md">
      初回限定30%オフ & 送料無料！今だけの特別価格
    </p> */}

    {/* CTA Button */}
    <div className="mt-8">
      <a href="/#sell" className="bg-red-500 hover:bg-red-600 text-white font-bold text-2xl py-4 px-12 rounded-full shadow-xl inline-block transition duration-300">
        今すぐ購入する
      </a>
    </div>

    {/* Risk-Free Assurance */}
    <p className="mt-6 text-lg text-gray-700">
      100%安心保証付き！品質に自信があります。  
      日本国内生産・無添加・最高品質。
    </p>

    {/* Supporting Image */}
    <div className="mt-8 flex justify-center">
      <img src="https://inyoumarket.com/public/media/webp/2021/04/VitaminC0426_005-xl.webp" 
        alt="Happy Japanese Woman" 
        className="w-72 h-72 object-cover rounded-full border-4 border-yellow-400 shadow-lg">
      </img>
    </div>

  </div>
</section>

      {/* <BestSellingFeature/> */}

{/* <BlogSection/> */}
{/* <InfluencersSection/> */}


      
    
        {/* <h2 className="text-3xl font-bold">お問い合わせ</h2>
        <p className="mt-4">ご質問がございましたら、お気軽にお問い合わせください。</p>
        <button className="mt-6 bg-white text-green-700 py-2 px-6 rounded-lg font-bold">
          お問い合わせはこちら
        </button> */}
        <Footer/>
 
    </div>
  );
};

export default LandingPage;
